"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbSubTabItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SbSubTabItem = function SbSubTabItem(props) {
  var className = props.className,
      id = props.id,
      selected = props.selected,
      children = props.children,
      onChange = props.onChange;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('sb-sub-tab-item', {
      selected: id === selected
    }, className),
    id: id,
    onClick: function onClick() {
      onChange(id);
    }
  }, children);
};

exports.SbSubTabItem = SbSubTabItem;
SbSubTabItem.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  id: _propTypes.default.string,
  onChange: _propTypes.default.func,
  selected: _propTypes.default.string
};
SbSubTabItem.defaultProps = {
  className: null,
  children: null,
  id: null,
  selected: null,
  onChange: function onChange() {}
};
//# sourceMappingURL=sb-sub-tab-item.js.map